<template>

  <div class="column col-10 col-mx-auto">




    <div class="wrap">
      <h3 class="entry-title">
        <i class="fas fa-hourglass-half"></i> Dziękujemy za Twoją cierpliwość, Twój wniosek jest w trakcie procesowania.
      </h3>


      <h3 class="entry-title">
         Niebawem się z Tobą skontaktujemy.
      </h3>


      <div class="form-group form-btn-wrap column col-10 col-mx-auto">

        

      </div>


    </div>

  </div>

</template>

<script>



  export default {

    name: 'ZetosTimeoutPage',


    data() {

      return {

      }
    },
  }
</script>

<style scoped>
  h3 i {
    color: #0bc268;
  }
  .fa-hourglass-half{
    margin-right:5px;
  }

  .entry-title {
    font-size: 32px;
    margin-block-end: 30px;
    text-align: center;
  }


  .form-btn-wrap {
    margin-top: .5rem;
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
  }

  .button {
    cursor: pointer;
    min-width: 260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;
    border-radius: 10px;
    border: 0px;
    margin: 0 .5rem;
  }

    .button.btn-prev {
      background-color: #dfdfdf;
      color: rgb(64, 64, 64);
    }

      .button.btn-prev:hover {
        box-shadow: inset -400px 0 0 0 #bebebe;
      }



  .wrap {
    position: relative;
    padding-top: 1rem;
    margin: 2rem 0;
  }

    .wrap::before {
      content: "";
      position: absolute;
      top: 0;
      left: -5em;
      right: 0;
      bottom: 0;
      display: block;
      background-color: #f7f7f7;
      border-radius: 0 90px 90px 0;
      -webkit-transform: skew(-17deg,0deg);
      transform: skew(-7deg,0deg);
      z-index: -2;
    }

    .wrap::after {
      content: "";
      position: absolute;
      top: 0;
      right: 50%;
      left: -100vw;
      bottom: 0;
      display: block;
      background-color: #f7f7f7;
      z-index: -2;
    }

  
</style>



// WEBPACK FOOTER //
// src/ZetosTimeoutPage.vue